import React from 'react'
import FileViewer from 'react-file-viewer'

export const DocumentViewer = ({ type = "pdf", url = "" }) => {
    return <FileViewer fileType={type} filePath={url} />
}